import Vue from "vue";
import Router from "vue-router";
import Menu from "@/components/menu/menu";
import Login from "@/components/login/login";

import home from "@/components/index/home";
//教师
import Teacher from "@/components/jiaoshi/Teacher";
import TeacherkeList from "@/components/jiaoshi/TeacherkeList";

//学生
import xStudent from "@/components/xuesheng/xStudent";
//班级
import bCourse from "@/components/banji/bCourse";
import bList from "@/components/banji/bList";
import bStudent from "@/components/banji/bStudent";
import bStudentEdit from "@/components/banji/bStudentEdit";
import bCourseEdit from "@/components/banji/bCourseEdit";
//课程
import keList from "@/components/kecheng/keList";
import addKe from "@/components/kecheng/addKe";
//作业
import zuoye from "@/components/zuoye/zuoye";
import zuoyeList from "@/components/zuoye/zuoyeList";
import zuoBan from "@/components/zuoye/zuoBan";
import zuoStudent from "@/components/zuoye/zuoStudent";
import zuoDati from "@/components/zuoye/zuoDati";
import zuoDatiDetail from "@/components/zuoye/zuoDatiDetail";
import addZuo from "@/components/zuoye/addZuo";
//院系
import yuanxi from "@/components/yuanxi/yuanxi";
import yuanBan from "@/components/yuanxi/yuanBan";

//题库
import tiku from "@/components/tiku/tiku";
import addtiku from "@/components/tiku/addtiku";

import sCourse from "@/components/shuju/sCourse";
import sCourseInfo from "@/components/shuju/sCourseInfo";
import sStudent from "@/components/shuju/sStudent";
import sStudentInfo from "@/components/shuju/sStudentInfo";
import sTeacher from "@/components/shuju/sTeacher";
import sTeacherInfo from "@/components/shuju/sTeacherInfo";




import Role from "@/components/role/index";
import Roleauth from "@/components/role/authUser";
//个人信息
import UserList from "@/components/user/index";
Vue.use(Router);

export default new Router({
	routes: [{
			path: '/',
			redirect: '/login'
		},
		{
			path: '/login',
			component: Login
		},
		{
			path: '/',
			redirect: '/menu'
		},
		{
			path: "/menu",
			component: Menu,
			children: [
				{
					path: "/home",
					component: home,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/Teacher",
					component: Teacher,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/TeacherkeList",
					component: TeacherkeList,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoyeList",
					component: zuoyeList,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/addZuo",
					component: addZuo,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoBan",
					component: zuoBan,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoDati",
					component: zuoDati,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoDatiDetail",
					component: zuoDatiDetail,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoStudent",
					component: zuoStudent,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/zuoye",
					component: zuoye,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/addKe",
					component: addKe,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/tiku",
					component: tiku,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/addtiku",
					component: addtiku,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/keList",
					component: keList,
					meta: {
						keepAlive: false
					}
				},
				
				{
					path: "/xStudent",
					component: xStudent,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/yuanxi",
					component: yuanxi,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/yuanBan",
					component: yuanBan,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/bList",
					component: bList,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/bStudent",
					component: bStudent,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/bStudentEdit",
					component: bStudentEdit,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/bCourse",
					component: bCourse,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/bCourseEdit",
					component: bCourseEdit,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sCourse",
					component: sCourse,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sCourseInfo",
					component: sCourseInfo,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sStudent",
					component: sStudent,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sStudentInfo",
					component: sStudentInfo,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sTeacher",
					component: sTeacher,
					meta: {
						keepAlive: false
					}
				},
				{
					path: "/sTeacherInfo",
					component: sTeacherInfo,
					meta: {
						keepAlive: false
					}
				}
			]
		},
		{
			path: "/role",
			component: Menu,
			children: [{
				path: "/role",
				component: Role,
				meta: {
					keepAlive: true
				}
			}, ]
		},
		{
			path: "/userlist",
			component: Menu,
			children: [{
					path: "/userlist",
					component: UserList,
					meta: {
						keepAlive: true
					}
				},
				{
					path: "/role-auth",
					component: Roleauth,
				},
			]
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js